import React from 'react'

export const RightIcon = () => (
  <svg width="40" height="40">
    <g fill="none" fillRule="evenodd">
      <rect width="40" height="40" fill="#FFF" fillOpacity=".8" rx="16" />
      <path
        fill="#AB9F94"
        d="M15.434 19.122v1.563a.47.47 0 00.47.469h4.53v2.617a.47.47 0 00.801.332l3.867-3.867a.468.468 0 000-.664l-3.867-3.868a.469.469 0 00-.8.333v2.617h-4.532a.47.47 0 00-.469.468z"
      />
    </g>
  </svg>
)
